import { render, staticRenderFns } from "./ListPointOfSale.vue?vue&type=template&id=e20b2242&scoped=true&"
import script from "./ListPointOfSale.vue?vue&type=script&lang=js&"
export * from "./ListPointOfSale.vue?vue&type=script&lang=js&"
import style0 from "./ListPointOfSale.vue?vue&type=style&index=0&id=e20b2242&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20b2242",
  null
  
)

export default component.exports